import { Button, ButtonProps, Grid } from '@mui/material'

import useSharedStyles from '../../utils/shared.styles'

interface IProps {
  startIcon?: React.ReactNode
}

const ButtonLink = ({ startIcon, onClick, children }: IProps & ButtonProps) => {
  const sharedClasses = useSharedStyles
  return (
    <Button onClick={onClick}>
      <Grid container={true} sx={[sharedClasses.centerContentVertical, { gap: 1 }]}>
        {startIcon}
        <div>{children}</div>
      </Grid>
    </Button>
  )
}

export default ButtonLink
